/* global session store config */
export default [
  {
    name: 'APP_LOGIN_SUCCESS',
    callback: function (e) {
      this.$router.push({ path: 'dashboard' });
    }
  },
  {
    name: 'APP_LOGOUT',
    callback: function (e) {
      if (config.host.indexOf('localhost') === -1 && session.role() === 'admin') {
        window.location = config.host + 'logout';
      } else {
        this.store.commit('resetStates');
        this.snackbar = {
          show: true,
          color: 'green',
          text: 'Logout successfully.'
        };
        this.$router.replace({ path: '/login' });
      }
    }
  },
  {
    name: 'APP_PAGE_LOADED',
    callback: function (e) {
    }
  },
  {
    name: 'APP_AUTH_FAILED',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'red',
        text: 'Token has expired'
      };
      this.$router.replace({ path: '/login' });
      // this.$router.push('/login');
      // this.$message.error('Token has expired');
    }
  },
  {
    name: 'APP_LOGIN_FAILED',
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: 'red',
        text: msg
      };
    }
  },
  {
    name: 'APP_BAD_REQUEST',
    // @error api response data
    callback: function (msg) {
      // this.$message.error(msg);
      if (window.getApp) {
        window.getApp.$emit('AppProgress', false);
      }
      this.snackbar = {
        show: true,
        color: 'red',
        text: msg
      };
    }
  },
  {
    name: 'APP_ACCESS_DENIED',
    // @error api response data
    callback: function (msg) {
      this.$message.error(msg);
      this.$router.push('/forbidden');
    }
  },
  {
    name: 'GO_ACCOUNT',
    // @error api response data
    callback: function (msg) {
      this.$router.push('account-info');
    }
  },
  
  {
    name: 'APP_RESOURCE_DELETED',
    // @error api response data
    callback: function (msg) {
      this.$message.success(msg);
    }
  },
  {
    name: 'APP_RESOURCE_UPDATED',
    // @error api response data
    callback: function (msg) {
      this.$message.success(msg);
    }
  },
  {
    name: 'MEDIATOR_STARTED',
    callback: function (msg) {

      this.Mediator.registerEvent('Agency', (messageEvent) => {

        if (messageEvent.data && session.isOnline()) {
          // Agency entity updated
          window.getApp.$emit('AGENCY', messageEvent);
        }
      });

      this.Mediator.registerEvent('Account', (messageEvent) => {
        // Account entity updated
        if (messageEvent.data && session.isOnline()) {
          window.getApp.$emit('ACCOUNT', messageEvent);
        }
      });

      this.Mediator.registerEvent('Photo', (messageEvent) => {
        console.log('New Photo', messageEvent);

        if (messageEvent.data && session.isOnline()) {

          let albumId = messageEvent.data.album;

          if (store.state.Account.letter_album === albumId) {

            window.getApp.$emit('NEW_LETTER_PHOTO', messageEvent);

          } else {
            window.getApp.$emit('NEW_ALBUM_PHOTO', messageEvent);
          }
        }
      });

      this.Mediator.registerEvent('Message', (messageEvent) => {

        // console.log('New Message', messageEvent);

        if (messageEvent.data && session.isOnline() && typeof session.getSession().adminUser === 'undefined') {
          window.getApp.$emit('NEW_MESSAGE', messageEvent);
        }
      });

      this.Mediator.registerEvent('AgencyUpdate', (messageEvent) => {

        if (messageEvent.data && session.isOnline()) {
          window.getApp.$emit('AGENCY_UPDATE', messageEvent);
        }
      });

      this.Mediator.registerEvent('AccountUpdate', (messageEvent) => {

        if (messageEvent.data && session.isOnline()) {
          window.getApp.$emit('ACCOUNT_UPDATE', messageEvent);
        }
      });

      this.Mediator.registerEvent('Video', (messageEvent) => {

        if (messageEvent.data && session.isOnline()) {
          window.getApp.$emit('VIDEO', messageEvent);
        }
      });

      this.Mediator.registerEvent('Timeline', (messageEvent) => {

        if (messageEvent.data && session.isOnline()) {
          window.getApp.$emit('TIMELINE', messageEvent);
        }
      });

      this.Mediator.registerEvent('Project', (messageEvent) => {
        
        if (messageEvent.data && session.isOnline()) {
          window.getApp.$emit('Project', messageEvent);
        }
      });

      this.Mediator.registerEvent('Section', (messageEvent) => {
        
        if (messageEvent.data && session.isOnline()) {
          window.getApp.$emit('Section', messageEvent);
        }
      });

      this.Mediator.registerEvent('Log', (messageEvent) => {
        
        if (messageEvent.data && session.isOnline()) {
          window.getApp.$emit('Log', messageEvent);
        }
      });
    }
  },

];



// WEBPACK FOOTER //
// ./src/event.js